export type AdminPage = "overview" | "logs";

type AdminNavSidebarProps = {
  active: AdminPage;
  onNavigate: (page: AdminPage) => void;
};

const navItems: { id: AdminPage; label: string }[] = [
  { id: "overview", label: "Overview" },
  { id: "logs", label: "Logs" },
];

export const AdminNavSidebar = ({ active, onNavigate }: AdminNavSidebarProps) => (
  <aside className="admin-nav-sidebar">
    <div className="admin-nav-brand">Bouncer Admin</div>
    <nav className="admin-nav" aria-label="Admin pages">
      <ul className="admin-nav-list">
        {navItems.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              className={`admin-nav-item${active === item.id ? " active" : ""}`}
              onClick={() => onNavigate(item.id)}
              aria-current={active === item.id ? "page" : undefined}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  </aside>
);
